import createIcon from '../../createIcon';

/**
 * @component @name ReceiptLong
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSAzLjVMMTggMkwxNi41IDMuNUwxNSAyTDEzLjUgMy41TDEyIDJMMTAuNSAzLjVMOSAyTDcuNSAzLjVMNiAyVjE2SDNWMTlDMyAyMC42NiA0LjM0IDIyIDYgMjJIMThDMTkuNjYgMjIgMjEgMjAuNjYgMjEgMTlWMkwxOS41IDMuNVpNMTkgMTlDMTkgMTkuNTUgMTguNTUgMjAgMTggMjBDMTcuNDUgMjAgMTcgMTkuNTUgMTcgMTlWMTZIOFY1SDE5VjE5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1IDdIOVY5SDE1VjdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTggN0gxNlY5SDE4VjdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUgMTBIOVYxMkgxNVYxMFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOCAxMEgxNlYxMkgxOFYxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ReceiptLong = createIcon('ReceiptLong', [
  [
    'path',
    {
      d: 'M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2V16H3V19C3 20.66 4.34 22 6 22H18C19.66 22 21 20.66 21 19V2L19.5 3.5ZM19 19C19 19.55 18.55 20 18 20C17.45 20 17 19.55 17 19V16H8V5H19V19Z',
      key: 'vplddm',
    },
  ],
  ['path', { d: 'M15 7H9V9H15V7Z', key: '488wsz' }],
  ['path', { d: 'M18 7H16V9H18V7Z', key: '1nuwr4' }],
  ['path', { d: 'M15 10H9V12H15V10Z', key: 'gejxhl' }],
  ['path', { d: 'M18 10H16V12H18V10Z', key: '1539r4' }],
]);

export default ReceiptLong;
